import Resource from './Resource';

export default class Notifications extends Resource{
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !!routeParams.setting ? `notification-system/:setting` : 'notification-system/all-preferences';

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	put() {
		return this.request('put');
	}
}
